AoPS.Utils.initKeyChain(AoPS, "KeepLearning", "Models");

AoPS.KeepLearning.Models = (function (Models) {
	Models.Index = AoPS.Model.extend({
		initialize: function () {},
	});

	return Models;
})(AoPS.KeepLearning.Models || {});
